import { useState } from "react"

type CobrowseState = {
  loading: boolean
  error: Error | null
  code: string | null
  generate: () => Promise<void>
}

export const useGenerateCobrowseCode = (): CobrowseState => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)
  const [code, setCode] = useState<string | null>(null)

  const generate = async () => {
    setLoading(true)
    setError(null)
    setCode(null)

    try {
      window.CobrowseIO = window.CobrowseIO || []

      if (window.CobrowseIO && window.CobrowseIO.client) {
        await window.CobrowseIO.client()
        const sessionCode = await (window.CobrowseIO.createSessionCode as () => Promise<string>)()
        setCode(sessionCode)
      } else {
        throw new Error("CobrowseIO client not found")
      }
    } catch (err) {
      setError(err as Error)
    } finally {
      setLoading(false)
    }
  }

  return { loading, error, code, generate }
}
